export const getCustomerNameOrEmail = (customer) =>
  customer.firstname ? customer.firstname + customer.lastname : customer.name

export const getRemainingCustomerNumber = (allCustomer, slicedCustomer) =>
  allCustomer.length - slicedCustomer.length



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerModal/utils.js